import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { ProductType } from "common";
import { ProductChoiceItem } from "./ProductChoiceItem";
import { findFilterName, sortChoices } from "shared/helpers";
import { fetchFiltersAttempt } from "store/filters/filtersActions";
import { selectFilters } from "store/filters/filtersSelectors";
const getMaxCount = (product) => {
    var _a;
    let maxCount = product.count || ((_a = product.element) === null || _a === void 0 ? void 0 : _a.count);
    if (!maxCount && product.type === ProductType.CHOICE_GROUP)
        maxCount = 0;
    else if (!maxCount)
        maxCount = 1000;
    return maxCount;
};
export function ProductChoices({ isAuthenticated, form, replace, toggleModal, AuthModal }) {
    var _a, _b, _c, _d, _e, _f;
    const dispatch = useDispatch();
    const [activeCategory, setActiveCategory] = useState(undefined); // Nouvel état pour suivre la catégorie active
    const [colorChartsSorted, setColorChartsSorted] = useState({});
    const [choicesSorted, setChoicesSorted] = useState();
    const filters = useSelector(selectFilters);
    useEffect(() => {
        setColorChartsSorted(sortChoices(form.values, "filter"));
    }, [form.values, filters]);
    useEffect(() => {
        dispatch(fetchFiltersAttempt());
    }, []);
    const increase = (index, choice) => {
        var _a;
        const maxCount = getMaxCount(form.values);
        const currentCount = ((_a = form.values.choices) === null || _a === void 0 ? void 0 : _a.reduce((acc, curr) => {
            acc += curr.quantity || 0;
            return acc;
        }, 0)) || 0;
        if (currentCount < maxCount)
            replace(index, Object.assign(Object.assign({}, choice), { quantity: (choice.quantity || 0) + 1 }));
    };
    const decrease = (index, choice) => {
        if (choice.quantity > 0)
            replace(index, Object.assign(Object.assign({}, choice), { quantity: (choice.quantity || 0) - 1 }));
    };
    const change = (event, index, choice) => {
        var _a;
        const maxCount = getMaxCount(form.values);
        const value = parseInt(event.target.value, 10);
        const currentCount = ((_a = form.values.choices) === null || _a === void 0 ? void 0 : _a.filter((x) => x._id !== choice._id).reduce((acc, curr) => {
            acc += curr.quantity || 0;
            return acc;
        }, 0)) || 0;
        replace(index, Object.assign(Object.assign({}, choice), { quantity: currentCount + value > maxCount ? maxCount - currentCount : value }));
    };
    return (React.createElement(React.Fragment, null,
        colorChartsSorted && Object.keys(colorChartsSorted).filter((key) => !!colorChartsSorted[key][0].filter).length > 0 && (React.createElement("div", { className: "k-product--subs_filter choices-categories" },
            React.createElement("div", { onClick: () => {
                    setChoicesSorted(undefined);
                    setActiveCategory(undefined); // Réinitialiser la catégorie active
                }, className: `k-product--subs_filter__item ${!choicesSorted ? 'active' : ''}` },
                React.createElement("h3", { "data-text": "Tous" },
                    React.createElement(FormattedMessage, { id: "Tous", defaultMessage: "Tous" }))), (_a = Object.keys(colorChartsSorted)) === null || _a === void 0 ? void 0 :
            _a.filter((key) => !!colorChartsSorted[key][0].filter).map((index) => (React.createElement("div", { key: index, onClick: () => {
                    setChoicesSorted(colorChartsSorted[index]);
                    setActiveCategory(index); // Définir la catégorie active
                }, className: `k-product--subs_filter__item choices-category ${activeCategory === index ? 'active' : ''}` },
                React.createElement("h3", { "data-text": findFilterName(filters, colorChartsSorted[index]) }, findFilterName(filters, colorChartsSorted[index]))))))),
        choicesSorted === undefined
            ?
                React.createElement("div", { className: `k-product--subs_grid ${((_b = form.values.choices) === null || _b === void 0 ? void 0 : _b.length) > 10 ? 'large' : ''}` }, (_c = form.values.choices) === null || _c === void 0 ? void 0 : _c.map((choice, index) => {
                    return React.createElement(ProductChoiceItem, Object.assign({ key: choice._id, cartProduct: form.values }, {
                        increment: () => !isAuthenticated ? toggleModal(AuthModal) : increase(index, choice),
                        decrement: () => decrease(index, choice),
                        onChange: (event) => change(event, index, choice)
                    }, { choice: choice }));
                }))
            :
                React.createElement("div", { className: `k-product--subs_grid ${((_d = form.values.choices) === null || _d === void 0 ? void 0 : _d.length) > 10 ? 'large' : ''}` }, (_f = (_e = form.values) === null || _e === void 0 ? void 0 : _e.choices) === null || _f === void 0 ? void 0 : _f.map((choice, index) => {
                    return (choicesSorted.findIndex((x) => x.code === choice.code) !== -1 &&
                        React.createElement(ProductChoiceItem, Object.assign({ key: choice._id, cartProduct: form.values }, {
                            increment: () => !isAuthenticated ? toggleModal(AuthModal) : increase(index, choice),
                            decrement: () => decrease(index, choice),
                            onChange: (event) => change(event, index, choice)
                        }, { choice: choice })));
                }))));
}
